'use client';

import type { ReactNode } from 'react';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import dynamic from 'next/dynamic';

const Devtools =
    process.env.NODE_ENV === 'production'
        ? () => null
        : dynamic(() => import('@components/devtools').then((m) => m.Devtools), { ssr: false });

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
        },
    },
});

export interface ProvidersProps {
    children: ReactNode;
}

export function Providers({ children }: Readonly<ProvidersProps>) {
    return (
        <QueryClientProvider client={queryClient}>
            {children}
            <Devtools />
        </QueryClientProvider>
    );
}
